
/* Change this file to get your personal Portfolio */

// Your Summary And Greeting Section

import emoji from "react-easy-emoji";

const greeting = {
  /* Your Summary And Greeting Section */
  username: "Ayushi",
  title: "Hi all, I'm Ayushi",
  subTitle: emoji("A passionate Software Developer 🚀 having an experience of building Full stack Web applications with Flask / Reactjs and Data Science lover.Creating and realising new possibilities and opportunities to pursue my dream"),
  resumeLink: "https://drive.google.com/file/d/1Id56JmqPigRRPDsEwQskJ4NP5Cy6qwQg/view?usp=sharing"
};

// Your Social Media Link

const socialMediaLinks = {

  github: "https://github.com/ayushianan",
  linkedin: "https://www.linkedin.com/in/ayushi-36876816a/",
  gmail: "github.com/ayushianan",
  twitter: "https://twitter.com/Ayushi21084272",
  facebook: "https://www.facebook.com/ayushi.anand.1023",
  instagram:"https://www.instagram.com/goldfishlol98/"
  // Instagram and Twitter are also supported in the links!
};

// Your Skills Section

const skillsSection = {
  title: "What i do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji("⚡ Simple Flask Blog-https://flaskayu.pythonanywhere.com/"),
    emoji("⚡ Develop highly interactive Front end / User Interfaces for your web applications"),
    emoji("⚡ Have worked with Databases and integrate them with web"),
    emoji("⚡ Have worked with various datasets from kaggle"),
    emoji("⚡ Keen learner of Reactjs")
  ],

/* Make Sure You include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "C++",
      logo: require("./assets/images/c++.png")
    },
    {
      skillName: "Algorithms",
      logo: require("./assets/images/algo.png")
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git"
    },
    {
      skillName: "VScode",
      logo: require("./assets/images/vscode.png")
    },
    {
      skillName: "Flask",
      logo: require("./assets/images/flask.jpg")
    },
    {
      skillName: "Django",
      logo: require("./assets/images/django.png")
    },
    {
      skillName: "Machine Learning",
      logo: require("./assets/images/ml.png")
    },
    {
      skillName: "Linux",
      fontAwesomeClassname: "fab fa-linux"
    },
    {
      skillName: "Hackerrank",
      fontAwesomeClassname: "fab fa-hackerrank"
    },
    {
      skillName: "Jekyll",
      logo: require("./assets/images/j.jpg")
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Competitive Programming",
      progressPercentage: "80%"
        //Insert relative proficiency in percentage
    },
    {
      Stack: "Reactjs",
      progressPercentage: "70%"
    },
    {
      Stack: "Backend",  //Insert stack or technology you have experience in
      progressPercentage: "60%"
    },
    {
      Stack: "Database",
      progressPercentage: "65%"
    },
    {
      Stack: "Java(oops)",
      progressPercentage: "70%"
    },
    {
      Stack: "Machine Learning",
      progressPercentage: "65%"
    },
    {
      Stack: "Ubuntu",
      progressPercentage: "60%"
    },
    {
      Stack: "Frontend/Design",
      progressPercentage: "50%"
    }
  ]
};


// Your top 3 work experiences

const workExperiences = {
  viewExperiences: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Microsoft Student Partner",  
      company: "Microsoft",
      companylogo: require("./assets/images/ms.png"),
      date: "Jan 2020 – Present",
      //desc: 
      descBullets: [
        "Selected as MSP’s by Microsoft among applicants from all over the globe.",
        "Organised various events and assisted students in various fields under this program.Interacted with other msp’s."
        //"Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      role: "Research intern",   
      company: "IFFCO Aonla",
      companylogo: require("./assets/images/iffco.jpeg"),
      date: "Jan 2019 – Feb 2019",
      descBullets: [
        "Worked with Oracle database and linking it with java web application",
        "Rendering data over an excel sheet.",
        "Analysed working of ERP’s, Employees Information System, Plant Maintenance Management System."
      ]
      //desc: "Worked with Oracle database and linking it with java web application.Rendering data over an excel sheet.Analysed working of ERP’s, Employees Information System, Plant Maintenance Management System."
    },
    {
      role: "Internship trainee",  
      company: "Wishfie",
      companylogo: require("./assets/images/w.png"),
      date: "Feb 2018 – Apr 2018",
      descBullets: [
        "Worked on promoting the app by speaking on day to day topics and interacting with other members in various debates."
      ]
      //desc: 
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: process.env.REACT_APP_GITHUB_TOKEN,
  githubUserName: "saadpasta", // Change to your github username to view your profile in Contact Section.
  showGithubProfile :"true" // Set true or false to show Contact profile using Github, defaults to false 
};


// Some Big Projects You have worked with your company

const bigProjects = {
  title: "Projects",
  subtitle: "Some Projects created as part of Hackathons and college projects",
  projects: [
    {
      descBullets: [
        "A Django application for students to keep record of notes.You can login to the system.",
        "There are options to add new notes or comments to any notes. An admin is there to manage the backend application."
      ],
      image: require("./assets/images/tech.jpg"),
      link: "https://github.com/ayushianan/techlearn"
    },
    {
      descBullets: [
        "It is an Open-source blogging website where new users can add their blogs.",
        "You can view all posts by a particular user.Also you can access user’s linkedin or github for contact.",
        "It is built using Jekyll and database with Django and firebase."
      ],
      image: require("./assets/images/glug.jpg"),
      link: "https://blog.glugmvit.com/"
    },
    {
      descBullets: [
        "It is Flask application used to control blood-bank transactions.",
        "User can register themselves,donate blood an admin can view users info an handles request page.",
        "Built using flask framework, MYSQL as database, html and bootstrap for frontend."
      ],
      image: require("./assets/images/dbms.jpg"),
      link: "https://github.com/ayushianan/Blood-Bank-Management-System"
    },
    {
      descBullets: [
        "Built a search engine using Inverted Index data structure which works on the principle of hashing.",
        "It maps frequency of word wrt to location in single file to whole document.",
        "Displays top 10 documents in decreasing order of frequencies of word searched with summary of document with searched word.",
        "Uses MongoDB to store data and python3 to iterate over the files."
      ],
      image: require("./assets/images/search.jpg"),
      link: "https://github.com/ayushianan/Search-Engine-implementation-for-databases"
    }
  ]
};

// Your Achievement Section Include Your Certification Talks and More

const achievementSection = {

  title: emoji("Achievements And Certifications 🏆 "),
  subtitle: "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achivementsCards: [
    {
      title: "Udacity-Pytorch scholar 2018.",
      subtitle: "Selected as scholar participant fot 2018 pytorch program",
      image: require("./assets/images/u.png"),
      footerLink: [
        { name: "Award Letter", url: "https://photos.app.goo.gl/tJHJumFASqxe3LJZ8" }
        
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle: "Developed a Google Assistant Action Quiz.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      footerLink: [{ name: "View Google Assistant Action", url: "https://console.actions.google.com/project/smash-5699b/overview" }]
    },

    {
      title: "Internshala Student Partner.",
      subtitle: "Selected as Internshala Student Partner.",
      image: require("./assets/images/isp.png"),
      footerLink: [
        { name: "Letter", url: "https://photos.app.goo.gl/28P3zuJKcRsZZ4Yz9" }
      ]
    },
    {
      title: "Womendroid hackathon2019",
      subtitle: "Participated in hackathon organised by Truecaller.",
      image: require("./assets/images/truec.jpeg"),
      footerLink: [
        { name: "Certificate", url: "https://photos.app.goo.gl/W3KWBDhYkUtDb6NC6" }
      ]
    },
    {
      title: "Volunteer",
      subtitle: "Volunteered at GDG Bangalore and Mozilla India.",
      image: require("./assets/images/gdg.png"),
      footerLink: [
        { }
      ]
    },
    {
      title: "InterCollege-VTU Games",
      subtitle: "・Presented college at InterCollege-VTU Games in Badminton and TableTennis,qualified till semifinals.",
      image: require("./assets/images/vtu.jpeg"),
      footerLink: [
        {}
      ]
    }
  ]
};

// Blogs Section

const blogSection = {

  title: "Blogs",
  subtitle: "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url: "https://blog.glugmvit.com/clustering/",
      title: "Machine Learning: Clustering Text documents",
      description: "Applying K-means Clustering algorithm to 20 newsgroup datasets to cluster most frequent words in articles together."
    },
    {
      url: "https://blog.glugmvit.com/expression-analysis/",
      title: "Deep Learning: Expression Analysis",
      description: "A neural network model to classify people as smiling or neutral using scikit-learn, OpenCV and TensorFlow."
    },
    {
      url: "https://blog.glugmvit.com/email-classifier/",
      title: "Machine Learning: Email classification",
      description: "A neural network model to classify people as smiling or neutral using scikit-learn, OpenCV and TensorFlow."
    }
  ]
};

// Talks Sections

const talkSection = {
  title: "Competitive coding",
  subtitle: emoji("I Love to solve real life problems 😅"),

  talks: [
    {
      title: "Codechef",
      subtitle: "Best rating 3-star",
      url: "https://www.codechef.com/users/ayushianan",
      //event_url: "https://www.facebook.com/events/2339906106275053/"
    },
    {
      title: "Hackerearth",
      subtitle: "Best rank May Circuits '20-'1218'",
      url: "https://www.hackerearth.com/@ayushi347",
      //event_url: "https://www.facebook.com/events/2339906106275053/"
    },
    {
      title: "Codeforces",
      subtitle: "Max rating='1389'",
      url: "https://codeforces.com/profile/ayushianan",
      //event_url: "https://www.facebook.com/events/2339906106275053/"
    },
    {
      title: "Hackerrank",
      subtitle: "",
      url: "https://www.hackerrank.com/ayushi2712?hr_r=1",
      //event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ]
};



const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle: "Open for any technical discussions!!!",
  number: "+91-7060042712",
  email_address: "ayushi2712@gmail.com"
};


export { greeting, socialMediaLinks, skillsSection, techStack, workExperiences, openSource, bigProjects, achievementSection, blogSection, talkSection,contactInfo};
